import { render, staticRenderFns } from "./Power15MinMaximum.vue?vue&type=template&id=bf3e172e&scoped=true&"
import script from "./Power15MinMaximum.vue?vue&type=script&lang=js&"
export * from "./Power15MinMaximum.vue?vue&type=script&lang=js&"
import style0 from "./Power15MinMaximum.vue?vue&type=style&index=0&id=bf3e172e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3e172e",
  null
  
)

export default component.exports